import VeeValidate from 'vee-validate'

/*
  Vee-validate na versão 2.0.0 beta-25 lançava exception quando a validação falhava no validateAll
  na versão 2.0.0 rc-18 não lanca exception e retorna um boolean para indicar se esta valido ou nao
  hack para versao rc-18 lancar exception e não termos que alterar em vários lugares
 */
let f = VeeValidate.Validator.prototype.validateAll;
VeeValidate.Validator.prototype.validateAll = function validateAll(values2) {
  return f.apply(this, values2).then(r => {
    if(!r){
      return Promise.reject(this);
    }
    return r;
  });
}

export default {
  ...VeeValidate
}



// WEBPACK FOOTER //
// ./src/custom-validate.js